import * as React from "react";
import GoBack from "../GoBack";
import Progress from "../Progress";
import { LeadContext } from "@/context/lead";
import { ButtonGroup } from "@/components/Shared";
import { useRouter } from "next/dist/client/router";
import { PreferredSpeeds as PreferredSpeedsType } from "@/types/index";

const PreferredSpeeds: React.FC<{
	data: PreferredSpeedsType;
}> = ({ data }) => {
	const router = useRouter();
	const [loading, setLoading] = React.useState<Boolean>(false);
	const { setPreferredSpeed } = React.useContext(LeadContext);

	const onClick = (evt: any) => {
		setLoading(true);
		setPreferredSpeed(evt.target.name);
		router.push("/journey/broadband/results").then(() => setLoading(false));
	};

	return (
		<section className="flex-grow-1 bg-blue">
			<div className="container d-flex flex-column flex-grow-1 align-items-center pt-5 pb-5">
				<div className="mb-5 w-100 container-sm-fixed">
					<Progress width={50} />
				</div>
				<div className="text-center">
					<div className="heading-sm fw-bold">{data.fields.title}</div>
				</div>
				<div className="container-sm-fixed row mt-5">
					<ButtonGroup
						items={data.fields.broadbandSpeeds}
						onClick={onClick}
						isLoading={loading}
					/>
				</div>
				<div className="mt-5 container-sm-fixed">
					<GoBack />
				</div>
			</div>
		</section>
	);
};

export default PreferredSpeeds;
